export function serviceLocationAddress(location: {
  street: string;
  number?: string | null;
  complement?: string | null;
  district: string;
  city: string;
  state: string;
}) {
  const streetLine = `${location.street}, ${location.number?.trim() || "s/n"}`;
  return [streetLine, location.complement?.trim(), location.district, `${location.city}/${location.state}`].filter(Boolean).join(" · ");
}
